import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: '8px !important',
    },
    card: {
      padding: '16px',
    },
    markerArea: {
      marginTop: '16px',
    },
    activeButton: {
      backgroundColor: MaterialPalette.primary.main,
      borderRadius: '20px',
    },
  }),
);

export default useStyles;
